export default {
  sm: '46.875rem',
  md: '54.857rem',
  lg: '73.143rem',
  xl: '91.429rem',
}
